import React from "react";

export const DealerIndicator = () => (
  <div className="dealerIconContainer">
    <div className="dealerIndicator" />
  </div>
);
